import React, { useEffect, useState } from "react";
import { AiOutlineDelete } from "react-icons/ai";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import {
  decrementQuantity,
  emptyCart,
  incrementQuantity,
  removeCartItem,
  totalAmount,
} from "../actions/action";
import emailjs from "emailjs-com";

import { NavLink, useNavigate } from "react-router-dom";
import { apiURL } from "../api/index";
import StripeCheckout from "react-stripe-checkout";

function Cart() {
  const cart = useSelector((state) => state.AddToCart);
  const [city, setCity] = useState("");
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");

  const dispatch = useDispatch();
  const Navigate = useNavigate();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const LoadPage = async () => {
      try {
        const res = await fetch(`${apiURL}/cart`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        });

        const data = await res.json();
        setCity(data.city);
        setAddress(data.address);
        setName(data.name);
        setEmail(data.email);
      } catch (error) {
        Navigate("/login");
      }
    };
    LoadPage();
  }, [Navigate]);

  function NetTotal() {
    const Total = cart.reduce((total, item) => {
      return total + item.price * item.quantity;
    }, 0);
    return Total;
  }

  function totalCartNumber() {
    const CartTotal = cart.reduce((total, item) => {
      return total + item.quantity;
    }, 0);
    return CartTotal;
  }

  const tAmount = NetTotal() + 5;
  const totalItemsPurchased = totalCartNumber();

  const sendEmail = () => {
    const emailParams = {
      user_email: email,
      user_subject: "Hello From Digital Mechanic",
      message: `Hi ${name}, and Thanks for ordering ${totalItemsPurchased} items. Your order is on the way, in the meanwhile you can confirm your order status at the order page or order screen of your mobile and website.`,
    };

    emailjs
      .send(
        "service_o2a6p2p",
        "template_ejext9s",
        emailParams,
        "user_2agKQgT6Jx0WnwCl0pwPP"
      )
      .then((result) => {
        console.log(result.text);
      })
      .catch((error) => {
        console.log(error.text);
      });
  };

  const makePayment = (token) => {
    // Function to truncate a string to a specified length
    const truncateString = (str, maxLength) => {
      if (str.length > maxLength) {
        return str.substring(0, maxLength - 3) + "...";
      }
      return str;
    };

    const truncatedProducts = cart.map((product) => ({
      id: product.id,
      name: truncateString(product.name, 100),
      price: product.price,
      quantity: product.quantity,
    }));

    const body = {
      tAmount,
      totalItemsPurchased,
      token,
      city,
      name,
      status: "Pending",
      address,
      products: truncatedProducts,
    };

    const headers = {
      "Content-Type": "application/json",
    };

    return fetch(`${apiURL}/payment`, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    })
      .then(() => {
        sendEmail();
        setMessage(
          "Your Order Has Been Completed Successfully! Now You Would Be Taken To The Main Screen."
        );
        setTimeout(() => {
          setMessage("");
          Navigate("/");
        }, 2000);
      })
      .catch((error) => {
        setMessage(
          "OOPS! There is some issue in the server. Please, try again later"
        );
        setTimeout(() => {
          setMessage("");
        }, 2000);
        console.log(error);
      });
  };
  const stripeKey = process.env.REACT_APP_STRIPE_CLIENT_SIDE_KEY;

  return (
    <>
      {message && (
        <div className="bg-green-600 top-0 text-white p-4 w-full text-center font-semibold sticky">
          {message}
        </div>
      )}
      <div className="font-primary">
        <div className="pl-5 pt-14 pb-10 w-[90%] mx-auto flex justify-start items-center">
          Home <MdOutlineKeyboardArrowRight size="20" /> Cart
          <MdOutlineKeyboardArrowRight size="20" />
        </div>
        {/* table of cart */}
        <div className="flex justify-between md:w-[88%] md:flex-row flex-col mx-auto">
          <div className="md:w-[70%] w-[88%] md:mx-0 mx-auto">
            <table className="w-full text-left">
              <thead>
                <tr className="bg-background text-gray-900">
                  <th className="py-2 px-4 font-semibold">Product</th>
                  <th className="py-2 px-4 font-semibold">Price</th>
                  <th className="py-2 px-4 font-semibold">Quantity</th>
                  <th className="py-2 px-4 font-semibold">Subtotal</th>
                  <th className="py-2 px-4 font-semibold"></th>
                </tr>
              </thead>
              <tbody>
                {cart.map((product) => {
                  return (
                    <tr key={product.id}>
                      <td className="py-2 px-4 font-bold text-primary flex items-center">
                        <img width="30" src={product.image} alt="product" />
                        <span className="pl-2">{product.name}</span>
                      </td>
                      <td className="py-2 px-4">${product.price}</td>
                      <td className="py-2 px-4">
                        <button
                          onClick={() => {
                            dispatch(decrementQuantity(product.id));
                            dispatch(totalAmount(product.id));
                          }}
                          className="bg-transparent text-black border px-2 border-gray-500"
                        >
                          -
                        </button>
                        <button className="cursor-auto bg-transparent text-black border px-4 border-gray-500">
                          {product.quantity}
                        </button>
                        <button
                          onClick={() => {
                            dispatch(incrementQuantity(product.id));
                            dispatch(totalAmount(product.id));
                          }}
                          className="bg-transparent text-black border px-2 border-gray-500"
                        >
                          +
                        </button>
                      </td>
                      <td className="py-2 px-4">
                        $
                        {product.quantity === 1 ? product.price : product.total}
                      </td>
                      <td className="py-2 px-4">
                        <button
                          onClick={() => dispatch(removeCartItem(product.id))}
                        >
                          <AiOutlineDelete />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="flex justify-between pt-10 pb-6">
              <NavLink
                to="/shop/category"
                className="bg-secondary text-white px-6 py-4 rounded-2xl"
              >
                Continue Shopping
              </NavLink>
              <button
                onClick={() => dispatch(emptyCart())}
                className="bg-transparent border border-red-400 text-red-600 px-6 py-4 rounded-2xl"
              >
                Clear Cart
              </button>
            </div>
          </div>

          {/* order summary */}
          <div className="pb-3 mb-5 right-0 top-0 flex justify-around items-start bg-white">
            <div className="flex flex-col pb-3 px-6 border border-gray-300 ">
              <h1 className="text-center bg-background p-2">Order Details</h1>
              <div className="flex justify-between py-5 font-semibold">
                <span>Sub Total</span>
                <span>${NetTotal()}</span>
              </div>
              <div className="flex justify-between font-semibold py-5">
                <span>Tax</span>
                <span>5</span>
              </div>
              <div className="relative">
                <select className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
                  <option value={city}>{city}</option>
                </select>
              </div>

              <div className="flex justify-between py-5 font-normal">
                <span>Total Amount</span>
                <span className="pl-1">
                  ${NetTotal() === 0 ? NetTotal() : NetTotal() + 5}
                </span>
              </div>
              {tAmount === 5 ? (
                <button className="text-white bg-secondary p-2 rounded-sm w-full">
                  Pay ${tAmount === 5 ? 0 : tAmount}
                </button>
              ) : (
                <StripeCheckout
                  stripeKey={stripeKey}
                  token={makePayment}
                  name="Digital Mechanic"
                  amount={tAmount * 100}
                >
                  <button className="text-white bg-secondary p-2 rounded-sm w-full">
                    Pay ${tAmount === 5 ? 0 : tAmount}
                  </button>
                </StripeCheckout>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Cart;
